const initialReconciliationState = {
  cardId: null,
  showSpinner : false
};

export const mangoPayReducer = (state = initialReconciliationState, action) => {
  switch (action.type) {
    case 'SET_CARD_ID': {
      return {...state, cardId: action.payload};
    }

    case 'SHOW_SPINNER': {
      return {...state, showSpinner: action.payload};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/MangoPay/mangoPayReducer.js